import { ElMessage } from 'element-plus'

export const MAX_UPLOAD_SIZE = 150 * 1024 * 1024

export const showUploadSizeError = (fileName: string) => {
  ElMessage.error({
    message: `文件过大，单个文件上限为 150MB。\n${fileName}`,
    customClass: 'upload-size-error',
    duration: 6000,
    showClose: true,
    offset: 80,
  })
}
